/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import * as Common from '../components/Common';

class BranchSearchPop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      keyword: '',
      branch_id: '',
      branchName: '',
      style: null,
      entities: null,
      isEmptyResult: false
    };
  }

  componentDidMount() {
    this.setState({ style: Common.getCenterPosStyle(this.layer) });
  }

  _doChangeBranchEvent = (e) => {
    this.setState({
      branch_id: e.target.dataset.branch_id,
      branchName: e.target.dataset.branchname
    });

    var layerBgTimer = setTimeout(() => {
      this.layerBg.click();

      clearTimeout(layerBgTimer);
    }, 200);
  }

  _doKeywordInputEvent = (e) => {
    this.setState({ keyword: e.target.value });
    
    if(e.key == "Enter") {
      this._doBranchSearch();
    }
  }

  _doBranchSearch = () => {
    var params = {
      keyword: this.state.keyword,
      orderBy: 'branchName'
    }

    Common.callApi('/hp/branches', 'post', params)
    .then(result => {
      if(result.resultCode.toLowerCase() === 'success') {
        if(result.resultDataList && result.resultDataList.length > 0) {
          this.setState({
            entities: result.resultDataList,
            isEmptyResult: false
          });
        } else {
          this.setState({
            entities: null,
            isEmptyResult: true
          });
        }
      }
    });
  }

  _renderBranchList() {
    if(this.state.entities && this.state.entities.length > 0) {
      return (
        this.state.entities.map((entity, index) => <li key={index} className={this.state.branch_id == entity.id ? 'active' : ''}><a href={null} data-branch_id={entity.id} data-branchname={entity.branchName} onClick={this._doChangeBranchEvent.bind(this)}>{entity.branchName}</a></li>)
      )
    } else if(this.state.isEmptyResult) {
      return (
        <li><a href={null}>검색 결과가 없습니다.</a></li>
      )
    } else {
      return ""
    }
  }

  render() {
    return (
      <div className="layer-pop" id="branch-search-pop" style={this.state.style} ref={ref => this.layer = ref}>	
	      <div className="bg" data-branch_id={this.state.branch_id} data-branchname={this.state.branchName} data-type="branchName" onClick={this.props.onClick} ref={ref => this.layerBg = ref}></div>

        <p className="search-input">
          <input type="text" className="fl" placeholder="지점명 또는 지역명을 입력하세요." ref={ref => this._inputKeyword = ref} onKeyUp={this._doKeywordInputEvent} />
          <a href={null} className="search-btn fr" onClick={this._doBranchSearch}>검색</a>
        </p>
        <ul className="sel-list-pop scroll" style={{ height: '300px' }}>
          {this._renderBranchList()}
        </ul>
      </div>
    )
  }
}

export default BranchSearchPop;